// ─── Booking Flight Zone Test IDs ────────────────────────────────────────────
// Usage: import { FLIGHT_* } from "@/test-ids"

// Flight search (FlightSearchEdit / FlightSearchEditv2)
export const FLIGHT_SEARCH_FORM = "flight-search-form";
export const FLIGHT_TRIP_TYPE_RADIO = "flight-trip-type-radio";
export const FLIGHT_ORIGIN_SELECTOR = "flight-origin-selector";
export const FLIGHT_DESTINATION_SELECTOR = "flight-destination-selector";
export const FLIGHT_DATE_PICKER = "flight-date-picker";
export const FLIGHT_RETURN_DATE_PICKER = "flight-return-date-picker";
export const FLIGHT_RANGE_DATE_PICKER = "flight-range-date-picker";
export const FLIGHT_AADVANTAGE_CHECKBOX = "flight-aadvantage-checkbox";
export const FLIGHT_PROMO_CODE_INPUT = "flight-promo-code-input";
export const FLIGHT_SEARCH_BUTTON = "flight-search-button";
export const FLIGHT_EDIT_BUTTON_DESKTOP = "edit-flight-search-desktop-btn";
export const FLIGHT_EDIT_BUTTON_MOBILE = "flight-edit-button-mobile";

// Guest selector
export const FLIGHT_GUEST_SELECTOR = "flight-guest-selector";
export const FLIGHT_GUEST_ADULT_COUNTER = "flight-guest-adult-counter";
export const FLIGHT_GUEST_CHILD_COUNTER = "flight-guest-child-counter";
export const FLIGHT_GUEST_INFANT_COUNTER = "flight-guest-infant-counter";

// Flight availability
export const FLIGHT_AVAILABILITY_LIST = "flight-availability-list";
export const FLIGHT_AVAILABILITY_SECTION = "flight-availability-section";
export const FLIGHT_DIRECT_SECTION = "flight-direct-section";
export const FLIGHT_CONNECTING_SECTION = "flight-connecting-section";
export const FLIGHT_STOPOVER_SECTION = "flight-stopover-section";

// Fare display
export const FLIGHT_FARE_DISPLAY = "flight-fare-display";
export const FLIGHT_FARE_DISPLAY_DEFAULT = "flight-fare-display-default";

// Flight card
export const FLIGHT_CARD = "flight-card-section";
export const FLIGHT_CARD_PRICE_PANEL = "flight-card-price-panel";

// Flight header
export const FLIGHT_HEADER = "flight-header";
export const FLIGHT_DEPARTURE_TIME = "flight-departure-time";
export const FLIGHT_DEPARTURE_CITY = "flight-departure-city";
export const FLIGHT_ARRIVAL_TIME = "flight-arrival-time";
export const FLIGHT_ARRIVAL_CITY = "flight-arrival-city";
export const FLIGHT_TYPE_BADGE = "flight-type-badge";
export const FLIGHT_TYPE_LABEL = "flight-type-label";
export const FLIGHT_DURATION = "flight-duration";
export const FLIGHT_OPERATED_BY = "flight-operated-by";
export const FLIGHT_ON_TIME_PERFORMANCE_LINK = "flight-on-time-performance-link";

// Flight rate panel
export const FLIGHT_RATE_PANEL = "flight-rate-panel";
export const FLIGHT_RATE_BUTTON = "flight-rate-button";
export const FLIGHT_RATE_LABEL = "flight-rate-label";
export const FLIGHT_RATE_TAX_LABEL = "flight-rate-tax-label";

// Discount club rate
export const FLIGHT_DISCOUNT_CLUB_PANEL = "discount-club-price-panel";
export const FLIGHT_DISCOUNT_CLUB_LABEL = "flight-discount-club-label";
export const FLIGHT_DISCOUNT_CLUB_PRICE = "flight-discount-club-price";
export const FLIGHT_DISCOUNT_CLUB_TAX_LABEL = "flight-discount-club-tax-label";

// Bundle section
export const FLIGHT_BUNDLE_SECTION = "flight-bundle-section";
export const FLIGHT_BUNDLE_AVAILABLE_RATES_LABEL = "flight-bundle-available-rates-label";
export const FLIGHT_BUNDLE_CLOSE_BUTTON = "flight-bundle-close-button";
export const FLIGHT_BUNDLE_COLLECTION = "flight-bundle-collection";

// Bundle card
export const FLIGHT_BUNDLE_CARD = (bundleName: string) =>
  `flight-bundle-card-${bundleName.toLowerCase()}-section`;
export const FLIGHT_BUNDLE_CARD_HEADER = (bundleName: string) =>
  `flight-bundle-card-header-${bundleName.toLowerCase()}`;
export const FLIGHT_BUNDLE_CARD_LUGGAGE = (bundleName: string) =>
  `flight-bundle-card-luggage-${bundleName.toLowerCase()}`;
export const FLIGHT_BUNDLE_CARD_ITEMS = (bundleName: string) =>
  `flight-bundle-card-items-${bundleName.toLowerCase()}`;
export const FLIGHT_BUNDLE_CARD_PRICE = (bundleName: string) =>
  `flight-bundle-card-price-${bundleName.toLowerCase()}`;
export const FLIGHT_BUNDLE_CARD_PER_SECTION = (bundleName: string) =>
  `flight-bundle-card-per-section-${bundleName.toLowerCase()}`;
export const FLIGHT_BUNDLE_SELECT_BUTTON = (bundleName: string) =>
  `flight-bundle-select-${bundleName.toLowerCase()}-btn`;

// Payment breakdown
export const FLIGHT_PAYMENT_BREAKDOWN_SECTION = "flight-payment-breakdown-section";

// Flight info/timeline
export const FLIGHT_INFO = "flight-info";
export const FLIGHT_TIMELINE = "flight-timeline";
export const FLIGHT_SECTION = "flight-section";
